<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12">
        <SelectVue
            v-if="unemployedDropdown && unemployedDropdown.length"
            v-model="filters.lastName"
            :options="unemployedDropdown"
            :is-clear="true"
            :placeholder="$t('placeholder.last_name')"/>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12">
        <SelectVue
            v-if="insuranceNumberDropdown && insuranceNumberDropdown.length"
            v-model="filters.insuranceNumber"
            :options="insuranceNumberDropdown"
            :is-clear="true"
            placeholder="Versicherungsnr"/>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12">
        <SelectVue
            v-if="aaNumberDropdown && aaNumberDropdown.length"
            v-model="filters.aaNumber"
            :options="aaNumberDropdown"
            :is-clear="true"
            :placeholder="'JC / AA Nummer'"/>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12">
        <SelectVue
            v-if="statusDropdown && statusDropdown.length"
            v-model="filters.status"
            :options="statusDropdown"
            :is-clear="true"
            :placeholder="$t('placeholder.status')"/>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-10 col-md-12 col-sm-12">
        <SelectVue
            v-if="officeDropdown && officeDropdown.length"
            v-model="filters['officeIds[]']"
            :options="officeDropdown"
            :is-clear="true"
            :is-multi="true"
            :placeholder="$t('placeholder.office_name')"/>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <button type="submit" class="btn btn-primary custom_search_button2" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
          <span v-if="!loading">{{ $t('general.button.search') }}</span>
          <span v-else>{{ $t('general.button.search_in_progress') }}</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script setup>

import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  unemployedDropdown: {
    type: Array,
    require: true,
  },
  aaNumberDropdown: {
    type: Array,
    require: true,
  },
  officeDropdown: {
    type: Array,
    require: true,
  },
  insuranceNumberDropdown: {
    type: Array,
    require: true,
  },
  statusDropdown: {
    type: Array,
    require: true,
  },
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit        = defineEmits([ 'search' ]);
const { filters } = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped></style>
